import React from 'react';

/**
 * SubNav - V4 pill-style filter tabs
 *
 * @param {array} items - Array of { id, label, icon? }
 * @param {string} activeId - Currently active item id
 * @param {function} onChange - Called with item id when selection changes
 * @param {boolean} stretch - If true, tabs stretch to fill container
 */
const SubNav = ({ items, activeId, onChange, stretch = false }) => {
  return (
    <nav className={`v4-subnav ${stretch ? 'v4-subnav--stretch' : ''}`}>
      {items.map((item) => (
        <button
          key={item.id}
          className={`v4-subnav__item ${activeId === item.id ? 'v4-subnav__item--active' : ''}`}
          onClick={() => onChange(item.id)}
        >
          {item.icon && <span className="v4-subnav__icon">{item.icon}</span>}
          <span className="v4-subnav__label">{item.label}</span>
        </button>
      ))}
    </nav>
  );
};

/**
 * PillTabs - Simpler version without icons, inline background
 */
const PillTabs = ({ tabs, activeTab, onChange }) => {
  return (
    <div className="v4-pill-tabs">
      {tabs.map((tab) => (
        <button
          key={tab}
          className={`v4-pill-tab ${activeTab === tab ? 'v4-pill-tab--active' : ''}`}
          onClick={() => onChange(tab)}
        >
          {tab}
        </button>
      ))}
    </div>
  );
};

export { PillTabs };
export default SubNav;
